<template>
    <div id="main">
        <div class="page page-container select-modal">
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{
                                $t('grade') +
                                (isUpdate
                                    ? grade.descricao
                                        ? `: ${grade.idgradeerp} - ${grade.descricao}`
                                        : `: ${grade.idgradeerp}`
                                    : grade.descricao
                                    ? `: ${grade.descricao}`
                                    : '')
                            }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('vendas') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'ven-grade' })">
                                        {{ $t('grades') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{ $route.params.id ? $route.params.id : $t('novo') }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="backToGradeList()"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!integracao && !isUpdate && permissao.create) ||
                                (!integracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="grade.idgradeerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!grade.idgradeerp"
                            />
                        </div>
                        <div class="column is-9">
                            <v-input
                                :id="generateId(6)"
                                ref="descricaoInput"
                                v-model="grade.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grade.descricao"
                                uppercase
                                title="descricao"
                                :required="true"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(2)"
                                ref="titulolinhaInput"
                                v-model="grade.titulolinha"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grade.titulolinha"
                                uppercase
                                title="titulolinha"
                                tooltipLabel="tooltip-titulolinha"
                                tooltipPosition="is-right"
                                tooltipSize="is-small"
                                :tooltipMultilined="true"
                                :required="true"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(3)"
                                ref="titulocolunaInput"
                                v-model="grade.titulocoluna"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grade.titulocoluna"
                                uppercase
                                title="titulocoluna"
                                tooltipLabel="tooltip-titulocoluna"
                                tooltipPosition="is-right"
                                tooltipSize="is-small"
                                :tooltipMultilined="true"
                                :required="true"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(4)"
                                ref="situacaoSelect"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="!isUpdate"
                                title="situacao"
                                required
                            />
                        </div>
                    </div>
                    <div v-if="tabelaLiberada && !loadingTabela">
                        <label for="grade" v-text="$t('grade')" />
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="$t('tela-grade-info')"
                        />
                    </div>
                </div>

                <!-- Grade linha coluna -->

                <div v-if="isUpdate">
                    <hr />
                    <div class="form-columns-fit mb-2">
                        <div class="columns is-flex-wrap">
                            <div class="column is-6">
                                <div class="field has-addons">
                                    <div class="control is-expanded">
                                        <vss-select
                                            :id="generateId(4)"
                                            ref="situacaoSelect"
                                            title="vincular-linha"
                                            :options="linhaSelectFiltered"
                                            v-model="linhaSelected"
                                            :loading="linhaLoading"
                                            @search="loadAllLinhas"
                                            searchable
                                            clearable
                                            placeholder="selecione"
                                            class="select-width"
                                        />
                                    </div>
                                    <div class="control padding-label padding-label-custom">
                                        <b-button
                                            @click="insertLinha"
                                            icon-right="check"
                                            :disabled="linhaSelected == null"
                                            v-tippy
                                            :title="$t('vincular')"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="field has-addons">
                                    <div class="control is-expanded">
                                        <vss-select
                                            :id="generateId(4)"
                                            ref="colunaSelect"
                                            title="vincular-coluna"
                                            :options="colunaSelectFiltered"
                                            v-model="colunaSelected"
                                            :loading="colunaLoading"
                                            @search="loadAllColunas"
                                            searchable
                                            clearable
                                            class="select-width"
                                            placeholder="selecione"
                                        />
                                    </div>
                                    <div class="control padding-label padding-label-custom">
                                        <b-button
                                            @click="insertColuna"
                                            icon-right="check"
                                            :disabled="colunaSelected == null"
                                            v-tippy
                                            :title="$t('vincular')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content-overflow">
                        <div class="flex-table">
                            <div class="flex-col has-text-centered">
                                <!-- Orientação -->
                                <div class="flex-cell flex-cell-info">
                                    <strong>
                                        <b-icon size="is-small" icon="arrow-down" />
                                        {{ $t('linha') }} | {{ $t('coluna') }}
                                        <b-icon size="is-small" icon="arrow-right" />
                                    </strong>
                                </div>
                                <!-- Linhas -->
                                <div
                                    class="flex-cell"
                                    v-for="linha in grade.assGradeGradeLinhas"
                                    :key="linha.idgradelinha"
                                    :title="linha.gradeLinha.idgradelinhaerp"
                                    :class="[
                                        { 'flex-cell-new': !linha.idassgradegradelinha },
                                        { 'flex-cell-deleted': linha.replicapda == 2 },
                                    ]"
                                >
                                    <div class="flex-cell-text">
                                        {{ linha.gradeLinha.descricao }}
                                    </div>
                                    <!-- Ações -->
                                    <div class="flex-action-box">
                                        <div class="flex-action flex-action-center">
                                            <b-button
                                                size="is-small"
                                                :icon-right="
                                                    linha.replicapda == 3 ? 'delete' : 'check'
                                                "
                                                :type="
                                                    linha.replicapda == 3
                                                        ? 'is-danger'
                                                        : 'is-primary'
                                                "
                                                @click="promptChangeSituacao(linha, 'linha')"
                                                v-tippy
                                                :title="
                                                    linha.replicapda == 3
                                                        ? $t('desativar')
                                                        : $t('reativar')
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Colunas -->
                            <div
                                class="flex-col has-text-centered"
                                v-for="coluna in grade.assGradeGradeColunas"
                                :key="coluna.idgradecoluna"
                            >
                                <div
                                    class="flex-cell"
                                    :class="[
                                        { 'flex-cell-new': !coluna.idassgradegradecoluna },
                                        { 'flex-cell-deleted': coluna.replicapda == 2 },
                                    ]"
                                    :title="coluna.gradeColuna.idgradecolunaerp"
                                >
                                    <div class="flex-cell-text">
                                        {{ coluna.gradeColuna.descricao }}
                                    </div>
                                    <!-- Ações -->
                                    <div class="flex-action-box">
                                        <div class="flex-action flex-action-center">
                                            <b-button
                                                size="is-small"
                                                :icon-right="
                                                    coluna.replicapda == 3 ? 'delete' : 'check'
                                                "
                                                :type="
                                                    coluna.replicapda == 3
                                                        ? 'is-danger'
                                                        : 'is-primary'
                                                "
                                                @click="promptChangeSituacao(coluna, 'coluna')"
                                                v-tippy
                                                :title="
                                                    coluna.replicapda == 3
                                                        ? $t('desativar')
                                                        : $t('reativar')
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                                <!-- Conjunto linha coluna -->
                                <div
                                    class="flex-cell"
                                    v-for="linha in grade.assGradeGradeLinhas"
                                    :key="linha.idgradelinha"
                                    :class="[
                                        (!linha.idassgradegradelinha ||
                                            !coluna.idassgradegradecoluna) &&
                                        (linha.replicapda != 2 || coluna.replicapda != 2)
                                            ? 'flex-cell-new-intersection'
                                            : '',
                                        linha.replicapda == 2 || coluna.replicapda == 2
                                            ? 'flex-cell-deleted-intersection'
                                            : '',
                                    ]"
                                >
                                    <p class="is-size-7 is-italic flex-cell-text">
                                        {{ linha.gradeLinha.descricao }} |
                                        {{ coluna.gradeColuna.descricao }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GradeService from '@/services/vendas/GradeService';
import GradelinhaService from '@/services/vendas/GradelinhaService';
import GradeValidation from '@/services/validations/vendas/GradeValidation';
import Message from '@/models/Message';

export default {

    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('GRADE'),
            service: new GradeService(this.$http, this.$router),
            linhaService: new GradelinhaService(this.$http, this.$router),
            validation: new GradeValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            isUpdate: false,
            isEmpty: false,
            isChanged: false,

            grade: {
                idgrade: null,
                idgradeerp: null,
                descricao: null,
                titulolinha: null,
                titulocoluna: null,
                replicapda: null,
            },
            situacoes: [
                { label: 'inativo', id: 2 },
                { label: 'ativo', id: 3 },
            ],
            situacao: { label: 'ativo', id: 3 },
            isMobile: false,
            loadingTabela: false,
            tabelaLiberada: false,
            fields: [],

            colunaSelect: [],
            colunaSelectFiltered: null,
            colunaSelected: null,
            colunaLoading: true,

            linhaSelect: [],
            linhaSelectFiltered: null,
            linhaSelected: null,
            linhaLoading: true,
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-grade');
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'grade' },
            });
        } else {
            if (this.isUpdate) {
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        loadAllLinhas(search = '.*') {
            this.linhaLoading = true;

            this.service
                .getAllLinhas(search)
                .then((body) => {
                    this.linhaSelect = [];
                    body.content.map((e) => {
                        this.linhaSelect.push({
                            id: e.idgradelinha,
                            idgradelinha: e.idgradelinha,
                            idgradelinhaerp: e.idgradelinhaerp,
                            descricao: e.descricao,
                            ordem: e.ordem,
                            label: `${this.$t('codigo')}: ${e.idgradelinhaerp} 
                                | ${e.descricao}`,
                        });
                    });
                })
                .finally((_) => {
                    this.linhaLoading = false;
                    this.filterLinhaSelect();
                });
        },
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        insertColuna(){
            this.colunaSelected.label = mapTosave(this.colunaSelected.label);
            let gradecolunaDescricao = this.colunaSelected.label;
            if (this.validationColunaLinha.validate(gradecolunaDescricao)) {
                for (let f of this.fields) {
                    if (
                        f.key.toLocaleUpperCase() == gradecolunaDescricao.toLocaleUpperCase() &&
                        f.ordem
                    ) {
                        let msg = 'msg-gradecoluna-duplicado';
                        return this.msgs.push(new Message('alert', msg, true));
                    }
                }

                let gradecoluna = Object.assign({});
                gradecoluna.id = 0;
                gradecoluna.key = gradecolunaDescricao;
                gradecoluna.ordem =
                    this.fields.length > 2 ? this.fields[this.fields.length - 2].ordem + 1 : 1;
                gradecoluna.idgrade = this.grade.idgrade;
                gradecoluna.origem = 'coluna';
                gradecoluna.situacao = 1;
                gradecoluna.width = 150;
                gradecoluna.sortable = false;
                gradecoluna.sortFn = false;
                this.fields.splice(this.fields.length - 1, 0, gradecoluna);
                setTimeout((e) => {
                    this.setDraggable(true);
                }, 250);
                this.colunasEdit = true;
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-add', true));
            }
        },
        insertLinha() {
            this.linhaSelected.label = mapTosave(this.linhaSelected.label);
            let gradelinhaDescricao = this.linhaSelected.label;
            if (this.validationColunaLinha.validate(gradelinhaDescricao)) {
                for (let f of this.data) {
                    if (
                        f.descricao.toLocaleUpperCase() == gradelinhaDescricao.toLocaleUpperCase()
                    ) {
                        let msg = 'msg-gradelinha-duplicado';
                        return this.msgs.push(new Message('alert', msg, true));
                    }
                }

                let gradelinha = Object.assign({});
                gradelinha.idgradelinha = 0;
                gradelinha.descricao = gradelinhaDescricao;
                gradelinha.ordem =
                    this.data.length > 1 ? this.data[this.data.length - 2].ordem + 1 : 1;
                gradelinha.idgrade = this.grade.idgrade;
                gradelinha.origem = 'linha';
                gradelinha.situacao = 1;
                this.data.splice(this.data.length - 1, 0, gradelinha);
                this.linhasEdit = true;
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-add', true));
            }
        },
        insertBulk(service, objetos, origem) {
            service
                .save(objetos)
                .then((value) => {
                    if (value.message == null) {
                        let msg = `${origem}-cadastrada-sucesso`;
                        this.msgs.push(new Message('success', msg, true));
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    this.linhaLoading = false;
                    this.filterLinhaSelect();
                });
        },
        loadAllColunas(search = '.*') {
            this.colunaLoading = true;

            this.service
                .getAllColunas(search)
                .then((body) => {
                    this.colunaSelect = [];
                    body.content.map((e) => {
                        this.colunaSelect.push({
                            id: e.idgradecoluna,
                            idgradecoluna: e.idgradecoluna,
                            idgradecolunaerp: e.idgradecolunaerp,
                            descricao: e.descricao,
                            ordem: e.ordem,
                            label: `${this.$t('codigo')}: ${e.idgradecolunaerp} 
                                | ${e.descricao}`,
                        });
                    });
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    this.colunaLoading = false;
                    this.filterColunaSelect();
                });
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.grade = value.content;
                    this.situacao = this.situacoes.filter((e) => {
                        return e.id == this.grade.replicapda;
                    })[0];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        filterLinhaSelect() {
            let arrayIds = this.grade.assGradeGradeLinhas.map((m) => m.idgradelinha);
            let filtered = this.linhaSelect.filter((f) => !arrayIds.includes(f.idgradelinha));
            this.linhaSelectFiltered = filtered;
        },
        filterColunaSelect() {
            let arrayIds = this.grade.assGradeGradeColunas.map((m) => m.idgradecoluna);
            let filtered = this.colunaSelect.filter((f) => !arrayIds.includes(f.idgradecoluna));
            this.colunaSelectFiltered = filtered;
        },
        insertLinha() {
            this.isChanged = true;

            let gradeLinha = {
                replicapda: 3,
                idgrade: this.grade.id,
                idgradelinha: this.linhaSelected.id,
                gradeLinha: {
                    idgradelinha: this.linhaSelected.id,
                    idgradelinhaerp: this.linhaSelected.idgradelinhaerp,
                    descricao: this.linhaSelected.descricao,
                    ordem: this.linhaSelected.ordem,
                },
            };
            this.grade.assGradeGradeLinhas.push(gradeLinha);
            this.grade.assGradeGradeLinhas.sort((a, b) => a.gradeLinha.ordem - b.gradeLinha.ordem);
            this.linhaSelected = null;
            this.filterLinhaSelect();
        },
        insertColuna() {
            this.isChanged = true;

            let gradeColuna = {
                replicapda: 3,
                idgrade: this.grade.id,
                idgradecoluna: this.colunaSelected.id,
                gradeColuna: {
                    idgradecoluna: this.colunaSelected.id,
                    idgradecolunaerp: this.colunaSelected.idgradecolunaerp,
                    descricao: this.colunaSelected.descricao,
                    ordem: this.colunaSelected.ordem,
                },
            };
            this.grade.assGradeGradeColunas.push(gradeColuna);
            this.grade.assGradeGradeColunas.sort(
                (a, b) => a.gradeColuna.ordem - b.gradeColuna.ordem
            );
            this.colunaSelected = null;
            this.filterColunaSelect();
        },
        promptChangeSituacao(obj, origem) {
            let message = this.$t(
                    obj.replicapda == 3 
                        ? 'msg-confirma-desativar' 
                        : 'msg-confirma-reativar', 
                    { n: origem == 'coluna' ? obj.gradeColuna.descricao : obj.gradeLinha.descricao }
                );

            this.$root.confirm({
                message: message,
                onConfirm: (_) => {
                    origem == 'linha'
                        ? this.changeSituacaoLinha(obj)
                        : this.changeSituacaoColuna(obj);
                },
            });
        },
        changeSituacaoLinha(obj) {
            if (this.isNull(obj.idassgradegradelinha)) {
                const objWithIdIndex = this.grade.assGradeGradeLinhas.findIndex((fi) => {
                    return fi.idgradelinha == obj.idgradelinha;
                });
                if (objWithIdIndex > -1) {
                    this.grade.assGradeGradeLinhas.splice(objWithIdIndex, 1);
                }
            } else {
                obj.replicapda = obj.replicapda == 2 ? 3 : 2;
            }
            this.filterLinhaSelect();
        },
        changeSituacaoColuna(obj) {
            if (this.isNull(obj.idassgradegradecoluna)) {
                const objWithIdIndex = this.grade.assGradeGradeColunas.findIndex((fi) => {
                    return fi.idgradecoluna == obj.idgradecoluna;
                });
                if (objWithIdIndex > -1) {
                    this.grade.assGradeGradeColunas.splice(objWithIdIndex, 1);
                }
            } else {
                obj.replicapda = obj.replicapda == 2 ? 3 : 2;
            }
            this.filterColunaSelect();
        },
        save() {
            this.isSaving = true;
            let flagNew = !this.isUpdate;
            let gradeTemp = JSON.parse(JSON.stringify(this.grade));
            gradeTemp = this.mapTosave(gradeTemp);
            if (this.validation.validate(gradeTemp, this.$refs)) {
                gradeTemp.replicapda = this.situacao.id;

                this.service
                    .save(gradeTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'grade-cadastrada-sucesso';
                            if (this.grade.idgrade != null) {
                                msg = 'grade-editada-sucesso';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            if (flagNew) {
                                this.redirectToEdit(value.content.idgrade);
                            }
                        } else {
                            let message = value.message;
                            if (message && this.$t(message)) {
                                if (message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(message, { n: gradeTemp.idgradeerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar ação! ${e}`);
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        if (this.$route.query.id) {
                            this.$router.push({
                                name: 'ven-produto-dados-cadastrais-edit',
                                params: { id: this.$route.query['id'] },
                                query: {
                                    idgrade: this.$route.params.id,
                                    label: this.$route.query.label,
                                    dadoscadastrais: this.$route.query.dadoscadastrais,
                                    politicacomercial: this.$route.query.politicacomercial,
                                    analisecomercial: this.$route.query.analisecomercial,
                                },
                            });
                        } else if (!flagNew) {
                            this.redirectToList();
                        }
                        this.isChanged = false;
                        this.redirectToList();
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isSaving = false;
            }
        },
        redirectToList() {
            if (this.$route.query.id) {
                this.$router.push({
                    name: 'ven-produto-dados-cadastrais-edit',
                    params: { id: this.$route.query['id'] },
                    query: {
                        idgrade: this.$route.params.id,
                        label: this.$route.query.label,
                        dadoscadastrais: this.$route.query.dadoscadastrais,
                        politicacomercial: this.$route.query.politicacomercial,
                        analisecomercial: this.$route.query.analisecomercial,
                    },
                });
            } else {
                if (this.grade.idgrade != null) {
                    this.carregarDados(this.grade.idgrade);
                    if (!this.isUpdate) {
                        this.isUpdate = true;
                        this.redirectToEdit(this.grade.idgrade);
                    }
                }
            }
        },
        redirectToEdit(idgrade) {
            setTimeout(() => {
                this.$router.push({
                    name: 'ven-grade-edit',
                    params: { id: idgrade },
                });
            }, 1000);
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        backToGradeList() {
            this.$route.query.dadoscadastrais
                                    ? this.$router.push({
                                          name: 'ven-produto-dados-cadastrais-edit',
                                          params: { id: $route.query['id'] },
                                          query: {
                                              dadoscadastrais: $route.query.dadoscadastrais,
                                              politicacomercial: $route.query.politicacomercial,
                                              analisecomercial: $route.query.analisecomercial,
                                          },
                                      })
                                    : this.$router.push({ name: 'ven-grade-list' })
        }
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
    }

    .field.has-addons {
        display: -webkit-box !important;
    }

    .content-overflow {
        min-height: 100px;
        overflow-x: auto;
        white-space: nowrap;
        background-color: #f9f9f9;
        padding: 5px;
        border-radius: 6px;

        .flex-table {
            display: flex;
            min-width: min-content;

            // .flex-col {}

            .flex-cell {
                background-color: #fff;
                padding: 5px 10px;
                border: solid 1px silver;
                margin: 4px;
                position: relative;
                min-height: 40px;
                min-width: 150px;
                border-radius: 5px;
                .flex-cell-text {
                    display: inline-block;
                    vertical-align: middle;
                }
                .flex-action-box {
                    background-color: rgba(214, 214, 214, 0.7);
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    opacity: 0;
                    display: flex;
                    // justify-content: space-between;
                    justify-content: center;
                    align-items: center;
                    padding: 0 4px;

                    &:hover {
                        opacity: 1;
                    }
                    .flex-action {
                        opacity: 0.6;
                        &:hover {
                            opacity: 1;
                        }
                    }
                }
            }

            .flex-cell-new {
                background-color: #bfdaba;
            }
            .flex-cell-new-intersection {
                background-color: #dfe9dd;
            }
            .flex-cell-deleted {
                background-color: #e4aeae;
            }
            .flex-cell-deleted-intersection {
                background-color: #eccece;
            }
        }
    }
}
</style>
